<template>
	<div
		class="payment-input"
		:class="{
			'payment-input--error': error,
			'payment-input--readonly': readonly,
			'payment-input--disabled': disabled,
		}"
	>
		<label
			class="payment-input__item"
			v-for="method in methodsFiltered"
			:key="method.code"
			:class="{
				'payment-input__item--active': value === method.code,
				'payment-input__item--disabled': method.disabled,
				'payment-input__item--readonly': readonly,
				'payment-input__item--error': error,
			}"
		>
			<input
				type="radio"
				class="payment-input__item-radio"
				name="payment-input"
				:value="method.code"
				:checked="value === method.code"
				:disabled="disabled || method.disabled || (readonly && value != method.code)"
				@change="onInput"
			/>
			<span class="payment-input__item-toggle">
				<component
					class="payment-input__item-icon"
					:is="iconComponent(method.icon || paymentIcon(method.code))"
				/>
				<span
					class="payment-input__item-name"
					v-html="method.name"
				/>
			</span>
			<span
				class="payment-input__item-content"
				v-if="method.description || method.instructions"
			>
				<span
					class="payment-input__item-description"
					v-if="method.description"
					v-html="method.description"
				/>
				<span
					class="payment-input__item-instructions"
					v-if="method.instructions"
					v-html="method.instructions"
				/>
			</span>
		</label>

	</div>
</template>

<script>
export default {
	props: {
		value: String,
		error: Boolean,
		methods: Array,
		readonly: Boolean,
		disabled: Boolean,
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	data() {
		return {
			icons: {
				cash: 'cash',
			}
		};
	},
	computed: {
		methodsFiltered() {
			return this.methods.filter(method => !method.hidden)
		}
	},
	methods: {
		paymentIcon(method) {
			return this.icons[method] || 'credit-card';
		},
		onInput(e) {
			if (e.target.checked) {
				this.$emit('input', e.target.value);
			}
		},
	}
}
</script>

<style>

</style>
